export const Admin = 1;
export const Signatory = 2;
export const Staff = 3;

export const accessLevelList = [
    {
        id: 1,
        value: "Admin",
        other: "1",
    },
    {
        id: 2,
        value: "InitiatorAndApprover",
        other: "2",
    },
    {
        id: 3,
        value: "Initiator",
        other: "3",
    },
    {
        id: 4,
        value: "Approver",
        other: "4",
    },
    {
        id: 5,
        value: "Viewer",
        other: "5",
    },
];

export function getValueFromEnum(string) {
    const getObj = accessLevelList.find((item) => item.value === string);
    return getObj?.id;
}
export function getAccessStringFromEnum(id) {
    const getObj = accessLevelList.find((item) => item.id === id);
    return getObj?.value;
}
